export var TooltipPlacement;
(function (TooltipPlacement) {
    TooltipPlacement["ABOVE_LEFT"] = "above-left";
    TooltipPlacement["ABOVE_CENTER"] = "above-center";
    TooltipPlacement["ABOVE_RIGHT"] = "above-right";
    TooltipPlacement["BELOW_LEFT"] = "below-left";
    TooltipPlacement["BELOW_CENTER"] = "below-center";
    TooltipPlacement["BELOW_RIGHT"] = "below-right";
    TooltipPlacement["LEFT"] = "left";
    TooltipPlacement["RIGHT"] = "right";
})(TooltipPlacement || (TooltipPlacement = {}));
export var TooltipState;
(function (TooltipState) {
    TooltipState["DEFAULT"] = "default";
    TooltipState["ERROR"] = "error";
})(TooltipState || (TooltipState = {}));
